import FeatureLandingPage from '@/components/feature-landing-page/FeatureLandingPage';
import {
  ArrowDownTrayIcon,
  ComputerDesktopIcon,
  DocumentArrowDownIcon,
  PhotoIcon,
  RectangleGroupIcon,
  ArrowUpOnSquareStackIcon,
  ListBulletIcon,
  PencilIcon
} from '@heroicons/react/24/solid';
import heroImage from '@/public/ai-image-occlusion-hero.png';
import overviewImage from '@/public/ai-image-occlusion-overview.png';
import tutorialImage from '@/public/ai-image-occlusion-tutorial.png';

const overviewSection = {
  miniText: 'Enhance Your Study',
  title: 'Get hundreds of occlusions in seconds',
  image: overviewImage,
  description:
    'Automatically generate image occlusion flashcards from any file. Customize occlusions and export to Anki for robust study sessions.',
  features: [
    {
      name: 'Automatic image extraction.',
      description:
        'Upload a file and Limbiks will automatically extract images to create image occlusion flashcards.',
      icon: PhotoIcon
    },
    {
      name: 'Text block detection.',
      description:
        'AI detects and occludes blocks of text that need to be studied with editable boxes.',
      icon: RectangleGroupIcon
    },
    {
      name: 'Customizable occlusions.',
      description:
        'Edit occlusions with our easy to use editor. Add, remove, or combine occlusions as needed.',
      icon: PencilIcon
    },
    {
      name: 'Flashcards and multiple choice.',
      description:
        'Study image occlusions using flashcards or multiple-choice formats.',
      icon: ListBulletIcon
    },
    {
      name: 'Sync to Anki.',
      description:
        'Sync your image occlusion flashcards directly to Anki for seamless integration with your study routine.',
      icon: ArrowDownTrayIcon
    },
    {
      name: 'Anki Add-on.',
      description:
        'Bring our image occlusion technology directly into your Anki workflow with our AI Image Occlusion Add-on.',
      icon: ComputerDesktopIcon
    }
  ]
};

const tutorialSection = {
  miniText: 'Get Started',
  title: 'How It Works',
  image: tutorialImage,
  description:
    'Creating image occlusion flashcards is quick and user-friendly, helping you focus on what matters most: learning.',
  features: [
    {
      name: 'Upload your file(s).',
      description:
        'Upload your pdfs, word documents, presentations or images to automatically generate image occlusion flashcards.',
      icon: ArrowUpOnSquareStackIcon
    },
    {
      name: 'Customize occlusions.',
      description:
        'Use our intuitive editor to adjust occlusions as necessary, ensuring you occlude only what you need.',
      icon: PencilIcon
    },
    {
      name: 'Start studying.',
      description:
        'Take advantage of our easy to use study tools or seamlessly export your occlusions to Anki.',
      icon: DocumentArrowDownIcon
    }
  ]
};

export default function _AiImageOcclusion() {
  return (
    <FeatureLandingPage
      heroImage={heroImage}
      analyticsName="home_image_occlusions"
      overviewSection={overviewSection}
      tutorialSection={tutorialSection}
      heroMiniTitle="AI Image Occlusion"
      heroTitle="Generate image occlusions effortlessly"
      heroImageUrl="/ai-image-occlusion-hero.png"
      heroDescription="Upload any file, let Limbiks automatically generate image occlusions, customize them with our editor, and study using flashcards or multiple-choice. Export them directly to Anki for seamless study sessions."
    />
  );
}
